import { MouseEvent, TouchEvent } from "react";

export default function Exit({ onClick, id, style, className }: { onClick?: (event: MouseEvent | TouchEvent) => void, id?: string, style?: React.CSSProperties, className?: string }) {
	return (
		<div
			id={id}
			className={className ? `exit ${className}` : "exit"}
			style={style ?? {}}
			onClick={(event) => {
				event.stopPropagation();
				onClick?.(event);
			}}
		>
			<svg>
				<g>
					<line x1="20%" y1="20%" x2="80%" y2="80%"></line>
					<line x1="80%" y1="20%" x2="20%" y2="80%"></line>
				</g>
				✖
			</svg>
		</div>
	);
}
